import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: DefaultLayout,
    redirect: '/orders',
    children: [
      {
        path: '/orders',
        name: 'Zamówienia',
        redirect: '/orders/list',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        children: [
          {
            path: '/orders/list',
            name: 'Lista zamówień',
            component: () => import('@/views/orders/OrdersList'),
          },
          {
            path: '/orders/:id',
            name: 'Szczegóły zamówienia',
            component: () => import('@/views/orders/OrderPreview'),
          },
        ],
      },
      {
        path: '/page-owner/orders',
        name: 'Zamówienia z moich stron',
        meta: { pageOwner: true },
        component: () => import('@/views/pageOwner/PageOwnerOrdersList'),
      },
      {
        path: '/realizations',
        name: 'Realizacje',
        component: () => import('@/views/realizations/RealizationsList'),
      },
      {
        path: '/branches/:branchId',
        name: 'Lista usług oddziału',
        component: () => import('@/views/branchServices/BranchServicesList'),
      },
      {
        path: '/branches/services/:id',
        name: 'Szczegóły usługi',
        component: () => import('@/views/branchServices/ServicePreview.vue'),
      },
      {
        path: '/branches',
        name: 'Oddziały',
        component: () => import('@/views/branches/BranchesList'),
      },
      {
        path: '/wholesale-inquiries',
        name: 'Zapytania hurtowe',
        component: () =>
          import('@/views/wholesaleInquiries/WholesaleInquiriesList'),
      },
      {
        path: '/wholesale-inquiries/:id',
        name: 'Szczegóły zapytania hurtowego',
        component: () =>
          import('@/views/wholesaleInquiries/WholesaleInquiryPreview'),
      },
      {
        path: '/calendar',
        name: 'Kalendarz dostępności',
        component: () => import('@/views/calendar/Calendar'),
      },
      {
        path: '/price-lists',
        name: 'Cenniki najmu',
        component: () => import('@/views/priceLists/PriceListsList'),
      },
      {
        path: '/price-lists/:id',
        name: 'Szczegóły cennika',
        component: () => import('@/views/priceLists/PriceListsPreview'),
      },
      {
        path: '/additional-services-price',
        name: 'Cennik usług dodatkowych',
        component: () =>
          import('@/views/priceLists/AdditionalServicesPricesPreview'),
      },
    ],
  },
  {
    path: '/auth',
    redirect: '/pages/404',
    name: 'Auth',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: 'set-password',
        name: 'SetPassword',
        component: () => import('@/views/auth/SetPassword'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/Login'),
      },
      {
        path: 'reset-password',
        name: 'Reset hasła',
        component: () => import('@/views/auth/ResetPassword'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
